import '../App.css';
import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';
import React, { useState, useEffect } from 'react';
import {useNavigate} from 'react-router';
import {StyckeCompact} from "./ContentStyles";
import { Container, Button,Form,Alert,Modal } from 'react-bootstrap';
import { rules } from './PricingModule';

export default function Rules() {
    const [showAvtal,     setShowAvtal]     = useState(false);
    return (
        <div Style="display:inline;">
            <Modal show={showAvtal} onHide={()=> {setShowAvtal(!showAvtal)}} size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Avtal nookshop v{rules.version} ({rules.lastUpdate})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul>
                        {rules.paragraphs.map((p) => (<li>{p.Text}</li>))}
                    </ul>
                
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" className='QmeButton' onClick={()=> {setShowAvtal(!showAvtal)}}>Stäng</Button>
                </Modal.Footer>
            </Modal>

            &nbsp;<a href='' onClick={(e) => {e.preventDefault(); setShowAvtal(!showAvtal); return false;}}>Visa avtal</a>
    </div>
  )
};